








































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Endereco} from '@/model/resource/Endereco'
import {EnderecoCollection} from '@/model/collection/EnderecoCollection'
import {ListEnderecoSchema} from '@/schema/resource/Endereco/ListEnderecoSchema'
import {CsvEnderecoSchema} from '@/schema/resource/Endereco/CsvEnderecoSchema'

@Component
export default class ListEnderecoView extends Mixins(MixinQueryRouter) {
  schema = new ListEnderecoSchema()
  collection = new EnderecoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Endereco) {
    Helper.pushByName('editEndereco', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new EnderecoCollection().clearFilters().addFilter(params)

    await csv.listCsvEndereco()
    new CsvEnderecoSchema().downloadCsv(csv.all())
  }
}
